import { render, staticRenderFns } from "./XSNJSL.vue?vue&type=template&id=12bd0785&scoped=true&"
import script from "./XSNJSL.vue?vue&type=script&lang=js&"
export * from "./XSNJSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd0785",
  null
  
)

export default component.exports